var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 0C2.54638 0 0 2.54638 0 5.6875V20.3125C0 23.4536 2.54638 26 5.6875 26H8.66668V0H5.6875Z",
    fill: "#2E36A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 0V26H17.3336V0H8.66699Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3122 0H17.333V26H20.3122C23.4533 26 25.9997 23.4536 25.9997 20.3125V5.6875C25.9997 2.54638 23.4533 0 20.3122 0Z",
    fill: "#FF313C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrFlag);
export default __webpack_public_path__ + "static/media/FR_Flag.aec7599da0c8577cc44bf3fdcd4a03fe.svg";
export { ForwardRef as ReactComponent };